module.exports = __webpack_public_path__ + "static/img/course1.d36d317b.png";